export default {
    regionBaseData: 'Daten',
    regionActivities: 'Aktivitäten',
    regionDiaconias: 'Diakonie',
    regionAgeGroups: 'Altersgruppen',
    regionParishes: 'Kirchengemeinden'
}